module.exports = __webpack_public_path__ + "img/maincube_4.daa8e527.jpg";